import { ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { HstService } from '../../services/hst.service';
import { catchError, of, tap } from "rxjs";
import {
    DsButtonModule,
    DsFormFieldModule,
    DsLoadingAreaConfiguration,
    DsLoadingAreaService,
    DsSelectModule
} from "@bmw-ds/components";
import { Router } from "@angular/router";
import { FormsModule } from "@angular/forms";
import { UserInfoService } from '../../services/user-info.service';

@Component({
    selector: 'app-landing',
    standalone: true,
    templateUrl: './landing.component.html',
    styleUrls: ['./landing.component.scss'],
    imports: [
        DsFormFieldModule,
        DsSelectModule,
        DsButtonModule,
        FormsModule
    ]
})
export class LandingComponent implements OnInit {
    dealerOptions: { id: string; label: string }[] = [];
    selectedDealer: string | null = null;
    loadingAreaConfig: DsLoadingAreaConfiguration = {
        id: 'bodyLoading',
        loadingTitle: 'Loading...',
    };
    private readonly router = inject(Router);
    private readonly hstService = inject(HstService);
    private readonly cdr = inject(ChangeDetectorRef);
    private readonly loadingAreaService = inject(DsLoadingAreaService);
    private readonly userInfoService = inject(UserInfoService);
    ngOnInit() {
        this.loadDealers();
    }

    loadDealers() {
        this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);
        this.fetchDealers().subscribe({
            next: (dealers) => {
                this.mapToOptions(dealers);
                this.cdr.detectChanges();
            },
            error: (err) => console.error('Failed to load dealers', err),
            complete: () => {
                this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
            }
        });
    }

    private fetchDealers() {
        const isComDomain = window.location.hostname.endsWith('.com');
        const userId = this.userInfoService.getUserId();
        const dealerObservable = isComDomain
            ? this.hstService.getUserAgentList(userId)
            : this.hstService.getDealerList();

        return dealerObservable.pipe(
            tap((dealers) => {
                if (dealers && dealers.agentList) {
                    this.mapToOptions(dealers);
                }
            }),
            catchError((error) => {
                console.error('Error fetching dealer list:', error);
                return of([]); // fallback
            })
        );
    }

    private mapToOptions(dealers: any) {
        this.dealerOptions = dealers.agentList?.map((dealer: any) => {
            let code = dealer.code;
            if (code && code.length === 4) {
                code = '0' + code;
            }
            return {
                id: code,
                label: `${dealer.name} - ${code}`,
            };
        }) ?? [];
    }

    enterApp() {
        if (this.selectedDealer) {
            localStorage.setItem('dealerCode', this.selectedDealer);
            this.router.navigate(['/stock-unit-search']);
        }
    }
}
